module.exports = __webpack_public_path__ + "img/app.f05a6339.png";